'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M864 0h-832c-17.6 0-32 14.4-32 32v960c0 17.6 14.4 32 32 32h960c17.6 0 32-14.4 32-32v-832l-160-160zM256 32h512v256c0 17.6-14.4 32-32 32h-448c-17.6 0-32-14.4-32-32v-256zM896 992h-768v-416c0-35.348 28.654-64 64-64h640c35.346 0 64 28.652 64 64v416z' }),
        React.createElement('path', { d: 'M576 64h128v192h-128v-192z' }),
        React.createElement('path', { d: 'M256 576h512v64h-512v-64z' }),
        React.createElement('path', { d: 'M256 704h512v64h-512v-64z' }),
        React.createElement('path', { d: 'M256 832h512v64h-512v-64z' })
    ));
};